import { Badge } from '@mui/material';
import { makeStyles } from "@material-ui/core";
import React from 'react'
import { Stack, Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useState } from 'react';
import ProjectDetailModal from './Modals/ProjectDetailModal';
import { Draggable } from 'react-beautiful-dnd';

function MovingCard( props ) {

    const [data, setData] = useState(props.data);

    const useStyles = makeStyles((theme) => ({
        root: {
            background: '#B7E1FF',
            backgroundColor: '#ECF7FF',
            paddingInline: "1rem",
            borderRadius: 3,
            alignItems: 'center',
            marginBottom: "3px",
            height: '40px',
            "&:hover": { 
                backgroundColor: "#90EE90",
            }
        },
        badge: {
            backgroundColor: '#000000',
            color: '#FFC904',
        }
    }));

    const classes = useStyles();

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <Draggable key={data.project_id} index={props.index} draggableId={data.project_id.toString()}>
        {(provided) => (
            <div
                // key={props.data.project_id}
                // spreadable children
                {...provided.draggableProps}
                // returns dom node of object
                {...provided.dragHandleProps}
                ref={provided.innerRef}
            >

            <div style={{padding: 1}}>
                <ProjectDetailModal open={open} handleClose={handleClose} data={data}/> 
                <Stack direction="row" className={classes.root} gap={5} onClick={handleOpen}>
                    <Typography style={{width: '70%', overflow: 'hidden'}} noWrap>{data.name}</Typography>
                    {/* <Typography>{data.category}</Typography> */}
                    <Box style={{width: '15%', display: 'flex', justifyContent: 'center'}}>
                        <Badge classes={{badge: classes.badge}} badgeContent={data.end_semester}/>
                    </Box>
                    <Typography style={{width: '8%'}}>{data.rank !== 0 ? `# ${data.rank}` : ""}</Typography>
                </Stack>
            </div>
        </div>
        )}
    </Draggable>

    )
}

export default MovingCard